import React, { useContext, useEffect, useRef, useState } from 'react';
import { Col, Image, Row } from 'react-bootstrap';
import 'assets/styles/common.scss';
import AbsolutLogo from 'assets/images/WithoutLogin/absolute-logo.svg';
import AbsoluteLogoMobile from 'assets/images/WithoutLogin/absolute-logo-phone.svg';
import PhoneInput from 'react-phone-input-2';
import 'react-phone-input-2/lib/style.css';
import ArrowBack from 'assets/images/WithoutLogin/arrow-left.svg';
import { useNavigate } from 'react-router-dom';
import {
  doctorDashboard,
  doctorProfile,
  doctorSchedule,
  register,
  doctorSubscription,
} from 'routes/AppUrls';
import { LocaleContext } from 'routes/Router';
import { useDispatch, useSelector } from 'react-redux';
import { loginUsers } from 'store/login/LoginAction';
import firebase from 'components/firebase/firebase';
import { loginVerifyNumber } from 'store/verifyNumber/verifyNumberAction';
import LocalStorageManager from 'managers/LocalStorageManger';
import { MuiOtpInput } from 'mui-one-time-password-input';
import styled from 'styled-components';
import ReusableButton from 'components/commom/Button';
import { FormattedMessage } from 'react-intl';
import { ClearTokenRedirectLogin } from 'utils/general';
import { getProfileSectionData } from 'store/doctorProfileSection/doctorProfileSectionAction';
import {
  ACTIVE_INDEX,
  basicDetailsValue,
} from 'store/BasicDetailValues/BasicDetailValuesAction';
import CommonToast from 'components/commom/CommonToast';
import { CircularProgress } from '@mui/material';

const CustomMuiOtpInput = styled(MuiOtpInput)({
  '& .MuiOutlinedInput-root': {
    border: 'none',
    borderBottom: '1px solid #864629',
    borderRadius: '0px',
    fontSize: '32px',
    fontWeight: 400,
    lineHeight: '48px',
    color: '#3C3C3C',
  },
  '& .MuiOutlinedInput-notchedOutline': {
    border: 'none',
    borderRadius: '0px',
  },
});

const Login = () => {
  const recaptchaRef = useRef(null);
  const dispatch = useDispatch();
  const { showToast } = CommonToast();
  const navigate = useNavigate();
  const { locale } = useContext(LocaleContext);
  const [phoneNumber, setPhoneNumber] = useState('');
  const [countryCode, setCountryCode] = useState('');
  const [otpVerification, setOtpVerification] = useState('');
  const [loginScreenVisible, setLoginScreenVisible] = useState(true);
  const [otpValue, setOtpValue] = useState('');
  const verifyReducer = useSelector(
    (state) => state?.loginVerifyReducer?.loading
  );

  const [loginLoading, setLoginLoading] = useState(false);
  const [timeLeft, setTimeLeft] = useState(30);
  const [resendLoading, setResendLoading] = useState(false);
  const loginReducer = useSelector((state) => state?.loginReducer?.loading);

  const handleChange = (newValue) => {
    setOtpValue(newValue);
  };

  const handlePhoneChange = (value, country) => {
    const countryCode = `+${country?.dialCode}`;
    const contactNumber = value.replace(country?.dialCode, '').trim();

    setPhoneNumber(contactNumber);
    setCountryCode(countryCode);
  };
  const phoneNumberSignIn = () => {
    try {
      if (process.env.REACT_APP_AUTOMATION === 'false') {
        if (recaptchaRef.current) {
          recaptchaRef.current.innerHTML =
            '<div id="recaptcha-container"></div>';
        }
        if (window.recaptchaVerifier) {
          window.recaptchaVerifier.clear();
          window.recaptchaVerifier = null;
        }
        if (!window.recaptchaVerifier) {
          window.recaptchaVerifier = new firebase.auth.RecaptchaVerifier(
            'recaptcha-container',
            {
              size: 'invisible',
              callback: (response) => {},
              'expired-callback': () => {},
            }
          );
        }
      }
      firebase.auth().settings.appVerificationDisabledForTesting =
        process.env.REACT_APP_AUTOMATION === 'false' ? false : true;
      // if (recaptchaRef.current) {
      //   recaptchaRef.current.innerHTML = '<div id="recaptcha-container"></div>';
      // }
      // if (window.recaptchaVerifier) {
      //   window.recaptchaVerifier.clear();
      //   window.recaptchaVerifier = null;
      // }
      // if (!window.recaptchaVerifier) {
      //   window.recaptchaVerifier = new firebase.auth.RecaptchaVerifier(
      //     'recaptcha-container',
      //     {
      //       size: 'invisible',
      //       callback: (response) => {},
      //       'expired-callback': () => {},
      //     }
      //   );
      // }
      // firebase.auth().settings.appVerificationDisabledForTesting = false;
      window.recaptchaVerifier.render().then((widgetId) => {
        const contactNumber = `${countryCode}${phoneNumber.replace(/[\(\)\-\s]/g, '')}`;

        firebase
          .auth()
          .signInWithPhoneNumber(contactNumber, window.recaptchaVerifier)
          .then((confirmationResult) => {
            setLoginLoading(false);
            setLoginScreenVisible(false);
            setOtpVerification(confirmationResult);
          })
          .catch((error) => {
            if (error.code === 'auth/invalid-app-credential') {
              console.error('The application credentials are not valid.');
            }
          });
      });
    } catch (err) {
      console.error('Unexpected error:', err);
      setLoginScreenVisible(false);
    }
  };

  const hanldeLogin = () => {
    setLoginLoading(true);
    if (!phoneNumber) {
      showToast('Please Enter Phone Number', 'error');
      setLoginLoading(false);
    } else {
      const external = {
        run: true,
        handleFunction: (res) => {
          // phoneNumberSignIn();
          showToast(
            'This phone number is not registered. Please sign up first.',
            'error'
          );
          setLoginLoading(false);
        },
        verify: true,
        handleVerifyFunction: (res) => {
          phoneNumberSignIn();
        },
        error: true,
        handleFailerFunction: (res) => {
          showToast(res?.message, 'error');
          setLoginLoading(false);
        },
      };
      let body = {
        username: phoneNumber.toString(),
      };
      dispatch(loginVerifyNumber(body, external));
    }
  };

  const hanldeResend = () => {
    setResendLoading(true);
    try {
      if (recaptchaRef.current) {
        recaptchaRef.current.innerHTML = '<div id="recaptcha-container"></div>';
      }
      if (window.recaptchaVerifier) {
        window.recaptchaVerifier.clear();
        window.recaptchaVerifier = null;
      }
      if (!window.recaptchaVerifier) {
        window.recaptchaVerifier = new firebase.auth.RecaptchaVerifier(
          'recaptcha-container',
          {
            size: 'invisible',
            callback: (response) => {},
            'expired-callback': () => {},
          }
        );
      }
      firebase.auth().settings.appVerificationDisabledForTesting = false; // Ensure verification is enabled
      window.recaptchaVerifier.render().then((widgetId) => {
        const contactNumber = `${countryCode}${phoneNumber.replace(/[\(\)\-\s]/g, '')}`;

        firebase
          .auth()
          .signInWithPhoneNumber(contactNumber, window.recaptchaVerifier)
          .then((confirmationResult) => {
            setLoginScreenVisible(false);
            setOtpVerification(confirmationResult);
            setResendLoading(false);
            setTimeLeft(30);
          })
          .catch((error) => {
            if (error.code === 'auth/invalid-app-credential') {
              console.error('The application credentials are not valid.');
            }
          });
      });
    } catch (err) {
      console.error('Unexpected error:', err);
      setLoginScreenVisible(false);
    }
  };

  const createDoctor = () => {
    const external = {
      run: true,
      handleFunction: (res) => {
        showToast(res?.message, 'success');
        LocalStorageManager.setItem('token', res?.data?.key);
        getProfileSetion(res);
      },
      verify: true,
      handleVerifyFunction: (res) => {},
      error: true,
      handleFailerFunction: (res) => {
        showToast(res?.message, 'error');
      },
    };
    let body = {
      username: phoneNumber.toString(),
    };
    dispatch(loginUsers(body, external));
  };

  const handleverifyOtp = () => {
    if (process.env.REACT_APP_AUTOMATION === 'true') {
      if (otpValue !== '') {
        if (otpValue === '935016') {
          createDoctor();
        } else {
          showToast('Invalid OTP', 'error');
        }
      } else {
        showToast('Please enter 6 digit OTP', 'error');
      }
      return;
    }
    if (otpValue !== '') {
      otpVerification
        ?.confirm(otpValue)
        .then((result) => {
          createDoctor();
        })
        .catch((error) => {
          showToast('Invalid OTP. Try again.', 'error');
        });
    } else {
      showToast('Please enter 6 digit OTP', 'error');
    }
  };

  const getProfileSetion = (logindata) => {
    const external = {
      run: true,
      handleFunction: (res) => {
        const GoesToSubscriptionPage = LocalStorageManager.getItem(
          'is_subscription_link'
        );

        if (GoesToSubscriptionPage === 'Yes') {
          LocalStorageManager.removeItem('is_subscription_link');
          navigate(doctorSubscription(locale));
        }
        // else if (
        //   res?.data?.title?.slug === 'aesthetician' &&
        //   !res?.data?.is_availablity_set
        // ) {
        //   navigate(doctorDashboard(locale));
        // }
        else if (logindata?.data?.status === 'Pending') {
          dispatch(basicDetailsValue(ACTIVE_INDEX, 6));
          navigate(doctorProfile(locale));
        } else {
          if (res?.data?.doctor_verification?.in_review === true) {
            dispatch(
              basicDetailsValue(
                ACTIVE_INDEX,
                res?.data?.title?.id === 10 ? 2 : 6
              )
            );
            navigate(doctorProfile(locale));
          } else if (res?.data?.is_availablity_set === false) {
            dispatch(basicDetailsValue(ACTIVE_INDEX, 1));
            navigate(doctorSchedule(locale));
          } else {
            navigate(doctorDashboard(locale));
          }
        }
      },
      authorize: true,
      handleAuthorizeFunction: (res) => {
        ClearTokenRedirectLogin(navigate);
      },
      error: true,
      handleErrorFunction: (res) => {
        showToast(res?.message, 'error');
      },
    };
    dispatch(getProfileSectionData(external));
  };

  const handleRegister = () => {
    navigate(register(locale));
  };

  useEffect(() => {
    if (!loginScreenVisible) {
      if (timeLeft <= 0) {
        return;
      }

      const timer = setInterval(() => {
        setTimeLeft((prev) => prev - 1);
      }, 1000);

      return () => clearInterval(timer);
    }
  }, [timeLeft, loginScreenVisible]);

  return (
    <>
      {loginScreenVisible ? (
        <Row className="m-0 p-0 landing-image">
          <Row className="m-0 p-0 flex justify-content-center">
            <Col
              xs={12}
              sm={10}
              md={10}
              lg={6}
              xl={6}
              xxl={4}
              className="bg-light-100 m-sm-auto m-lg-auto login-card p-0"
            >
              <div class="p-15 sm:p-32">
                <div className="d-flex justify-content-center">
                  <Image src={AbsolutLogo} alt={'icon'} />
                </div>
                <div className="main-heading pt-8 sm:pt-24 family_outfit_semiBold_600">
                  Login
                </div>
                <div className="main-description pt-12 fs-16 family_outfit_regular_400 lh-208 fc-7F7F7F">
                  Please enter your details to sign in
                </div>
                <div>
                  <label
                    htmlFor="phone-input"
                    className="pt-24 fs-14 family_outfit_regular_400 lh-176 fc-3C3C3C"
                  >
                    Mobile Number
                  </label>
                  <PhoneInput
                    id="phone-input"
                    country={'in'}
                    inputProps={{
                      name: 'phoneNumber',
                      required: true,
                    }}
                    name={'phoneNumber'}
                    value={`${countryCode}${phoneNumber}`}
                    onChange={(value, country) =>
                      handlePhoneChange(value, country)
                    }
                    placeholder="Enter phone number"
                    inputClass="custom-input-register"
                    containerClass="custom-container-register"
                  />
                </div>
                <div className="sm:pt-28 mt-190 sm:mt-0">
                  <ReusableButton
                    fullWidth={true}
                    variant="outlined"
                    color="#F5F5F5"
                    fontSize="18px"
                    fontWeight="600"
                    padding="12px 50px"
                    height="44px"
                    bgColor="#375241"
                    brColor="#375241  "
                    fontFamily="outfit_semiBold"
                    onClick={() => {
                      !verifyReducer && !loginLoading && hanldeLogin();
                    }}
                    loading={loginLoading}
                  >
                    <FormattedMessage id="Login" />
                  </ReusableButton>
                </div>
                <div ref={recaptchaRef}></div>
                <div className="pt-40 flex justify-center fs-18 family_outfit_regular_400 lh-27 fc-7F7F7F">
                  Don’t have an account?{' '}
                  <span
                    className="underline underline-offset-1 pl-1 cursor-pointer ... family_outfit_semiBold_600"
                    onClick={() => handleRegister()}
                  >
                    Register
                  </span>
                </div>
              </div>
            </Col>
          </Row>
        </Row>
      ) : (
        <Row className="m-0 p-0 landing-image">
          <Row className="m-0 p-0 flex flex justify-center">
            <Col
              xs={12}
              sm={10}
              md={10}
              lg={6}
              xl={6}
              xxl={4}
              className="bg-light-100 m-sm-auto m-lg-auto otp-card p-0"
            >
              <div class="p-15 sm:p-32">
                <div className="d-none d-sm-flex justify-content-center">
                  <Image src={AbsolutLogo} alt={'icon'} />
                </div>
                <div className="d-flex d-sm-none justify-content-between">
                  <div>
                    <Image
                      src={ArrowBack}
                      alt={'icon'}
                      onClick={() => setLoginScreenVisible(true)}
                    />
                  </div>
                  <div>
                    <Image src={AbsoluteLogoMobile} alt={'icon'} />
                  </div>
                </div>
                <div className="main-heading pt-8 sm:pt-24 family_outfit_semiBold_600">
                  Verification
                </div>
                <div className="pt-12 fs-16 family_outfit_regular_400 lh-208 fc-998A7B pt-12">
                  Enter the OTP has been sent to{' '}
                  {`${countryCode} ${phoneNumber}`}
                </div>
                <div className="pt-24 sm:pt-40">
                  <CustomMuiOtpInput
                    length={6}
                    value={otpValue}
                    onChange={handleChange}
                  />
                </div>
                <div className="fs-18 family_outfit_regular_400 lh-27 fc-7F7F7F pt-40 flex justify-center">
                  Did not receive the OTP?
                </div>
                {timeLeft === 0 ? (
                  <div
                    className="fs-20 family_outfit_medium_500 fc-3C3C3C lh-30 pt-04 flex justify-center cursor-pointer ..."
                    onClick={() => {
                      !resendLoading && hanldeResend();
                    }}
                  >
                    {resendLoading ? (
                      <CircularProgress size={'25px'} color="#375241" />
                    ) : (
                      'Resend'
                    )}
                  </div>
                ) : (
                  <div className="fs-20 family_outfit_medium_500 fc-3C3C3C lh-30 pt-04 flex justify-center">
                    {timeLeft}s
                  </div>
                )}
                <div ref={recaptchaRef}></div>
                <div className="sm:pt-40 mt-80 sm:mt-0">
                  <ReusableButton
                    fullWidth={true}
                    variant="outlined"
                    color="#F5F5F5"
                    fontSize="18px"
                    fontWeight="600"
                    padding="12px 50px"
                    height="44px"
                    bgColor="#375241"
                    brColor="#375241  "
                    fontFamily="outfit_semiBold"
                    onClick={() => {
                      !loginReducer && handleverifyOtp();
                    }}
                    loading={loginReducer}
                  >
                    <FormattedMessage id="Verify" />
                  </ReusableButton>
                </div>
              </div>
            </Col>
          </Row>
        </Row>
      )}
    </>
  );
};
export default Login;
